//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    /**
     * ShowroomApiService
     *
     * Handles API communication to support the Showroom UIA experience
     */
  angular.module('curalate').service('ShowroomApiService', [
    '$http',
    'PromiseService',
    function(
            $http,
            PromiseService,
        ) {
      const REST_API_BASE = '/api/showroom';

      const getProductIdsFromFilters = (filters) => {
        return _(filters).safeGet('brandFilter') ?
                    _.chain(filters.brandFilter.brands).filter((brand) => {
                      return brand.isSelected;
                    }).map((brand) => {
                      return brand.productIds;
                    }).toArray().flatten().value()
                    : [];
      };

      const getOnSaleFromFilters = (filters) => {
        return _(filters).safeGet('onSaleFilter.isSelected');
      };

      this.getTributaryPreviewUrlAsync = (
                itemId,
                implId,
                name,
                filters,
                showDesktopExperience,
                passthroughUrl,
                useCuratedRecommendations,
                curatedProductIds,
                selectedLabels,
            ) => {
        const params = {
          implId,
          name,
          onSale: getOnSaleFromFilters(filters),
          brandFilterProductIds: getProductIdsFromFilters(filters),
          showDesktop: showDesktopExperience,
          passthroughUrl,
          useCuratedRecommendations,
          curatedProductIds,
          selectedLabels,
        };

        return PromiseService.processHttpResponse($http.post(`${REST_API_BASE}/item/${itemId}/implementation/preview-url`, params));
      };

      this.addTributaryInstanceForItemAsync = (itemId, implId, implName) => {
        const params = {
          implId,
          implName,
        };
        return PromiseService.processHttpResponse($http.put(`${REST_API_BASE}/item/${itemId}/implementation/instances`, params));
      };

      this.getTributaryImplAsync = (itemId, implType, sourceId) => {
        const params = {
          implType,
          sourceId,
        };

        return PromiseService.processHttpResponse($http.get(`${REST_API_BASE}/item/${itemId}/implementation`, { params }));
      };

      this.doesTributaryImplExistAsync = (itemId, implType, sourceId) => {
        const params = {
          implType,
          sourceId,
        };
        return PromiseService.processHttpResponse($http.get(`${REST_API_BASE}/item/${itemId}/implementation/exists`, { params }));
      };

      this.getProductsInfoAsync = (itemId) => {
        return PromiseService.processHttpResponse($http.get(`${REST_API_BASE}/item/${itemId}/products-info`));
      };

      const createUpdateParams = (
                implId,
                name,
                implType,
                sourceId,
                passthroughUrl,
                trackingParams,
                filters,
                instances,
                showDesktopExperience,
                emailCaptureConfig,
                customStringsConfig,
                curatedRecsId,
                useCuratedRecommendations,
                curatedProducts,
                selectedLabels,
                productContentState,
                mediaContentState,
                forceOverrideTrackingParams,
            ) => {
        const params = {
          implId,
          name,
          implType,
          sourceId,
          filters: {
            onSaleFilter: _(filters).safeGet('onSaleFilter.shouldShow') ? filters.onSaleFilter.isSelected : undefined,
            brandFilters: _(filters).safeGet('brandFilter.brands'),
          },
          instances,
          showDesktopExperience,
          emailCaptureConfig,
          customStringsConfig,
          curatedRecsId,
          useCuratedRecommendations,
          curatedProducts,
          selectedLabels,
          productContentState,
          mediaContentState,
        };

        if (passthroughUrl && !showDesktopExperience) {
          params.passthroughUrl = passthroughUrl;
        }

        if (trackingParams) {
          params.trackingParameters = trackingParams;
        }

        if (forceOverrideTrackingParams) {
          params.forceOverrideTrackingParams = forceOverrideTrackingParams;
        }

        return params;
      };

      this.updateTributaryImplAsync = (
                implId,
                name,
                implType,
                sourceId,
                itemId,
                passthroughUrl,
                trackingParams,
                filters,
                instances,
                showDesktopExperience,
                emailCaptureConfig,
                customStringsConfig,
                curatedRecsId,
                useCuratedRecommendations,
                curatedProducts,
                selectedLabels,
                productContentState,
                mediaContentState,
                forceOverrideTrackingParams,
            ) => {
        const params = createUpdateParams(
                    implId,
                    name,
                    implType,
                    sourceId,
                    passthroughUrl,
                    trackingParams,
                    filters,
                    instances,
                    showDesktopExperience,
                    emailCaptureConfig,
                    customStringsConfig,
                    curatedRecsId,
                    useCuratedRecommendations,
                    curatedProducts,
                    selectedLabels,
                    productContentState,
                    mediaContentState,
                    forceOverrideTrackingParams,
                );

        return PromiseService.processHttpResponse(
                    $http.put(`${REST_API_BASE}/item/${itemId}/implementation`, params),
                );
      };

      this.updatePreviewImplAsync = (
                implId,
                name,
                implType,
                sourceId,
                itemId,
                passthroughUrl,
                filters,
                showDesktopExperience,
                emailCaptureConfig,
                customStringsConfig,
                curatedRecsId,
                useCuratedRecommendations,
                curatedProducts,
                selectedLabels,
                productContentState,
                mediaContentState,
                forceOverrideTrackingParams,
            ) => {
        const params = createUpdateParams(
                    implId,
                    name,
                    implType,
                    sourceId,
                    passthroughUrl,
                    null, // tracking params
                    filters,
                    [], // instances
                    showDesktopExperience,
                    emailCaptureConfig,
                    customStringsConfig,
                    curatedRecsId,
                    useCuratedRecommendations,
                    curatedProducts,
                    selectedLabels,
                    productContentState,
                    mediaContentState,
                    forceOverrideTrackingParams,
                );

        return PromiseService.processHttpResponse(
                    $http.put(`${REST_API_BASE}/item/${itemId}/implementation/preview`, params),
                );
      };

      this.getTributaryImplShortLinkAsync = (implId, name, sourceId, sourceType, instanceId) => {
        const params = {
          implId,
          name,
          sourceId,
          sourceType,
          instanceId,
        };

        return PromiseService.processHttpResponse(
                    $http.post(`${REST_API_BASE}/short-link`, params),
                );
      };

      this.getContextualShowroomFromUrl = (showroomUrl, implementationType, sourceId) => {
        const params = {
          showroomUrl,
          implementationType,
          sourceId,
        };

        return PromiseService.processHttpResponse(
                    $http.post(`${REST_API_BASE}/contextual-showroom`, params),
                );
      };

      this.clearTributaryImplCache = (implId, implName) => {
        const params = {
          implId,
          implName,
        };

        PromiseService.processHttpResponse(
                    $http.post(`${REST_API_BASE}/clear-cache`, params),
                );
      };
    },
  ]);
})();
